/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import {
  showRoleDetail,
  showRole,
  IsPermisionOidRequired,
} from "../../../../redux/actions";
import {
  responseRoleDetail,
  responseRole,
  responseMiddleware,
} from "../../../../redux/reducers";
import "./style.scss";
import { useScreenSize } from "../../../../utils/media-query";
import RoleDetailTableList from "./RoleDetailTable";
import UsingIntl from "../../../../services/using_intl";

export default function RoleDetailsPage() {
  // get slug
  const { slug } = useParams();
  const history = useHistory();
  const { isXSmall } = useScreenSize();
  const [filterStatus, setFilterStatus] = useState("");
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const { roleDetail } = useSelector(responseRoleDetail);
  const { role } = useSelector(responseRole);
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    UsingIntl();
    dispatch(IsPermisionOidRequired());
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(showRoleDetail(slug ? slug : ""));
      dispatch(showRole());
    }
  }, [middleware]);

  const onValueSelectChanged = ({ value }) => {
    dispatch(showRoleDetail(value));
    setFilterStatus(value);
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <Link to="/permissions/roles/list" className={"breadcrumb-back"}>
            <i className="dx-icon-back"></i> {formatMessage("Back")}
          </Link>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/permissions" className={"breadcrumb-item"}>
            {formatMessage("Permission")}
          </Link>
          <Link to="/roles" className={"breadcrumb-item"}>
            {formatMessage("Role")}
          </Link>
          <Link to="/roles" className={"breadcrumb-item"}>
            {formatMessage("RoleDetail")}
          </Link>
          <span className={"breadcrumb-item active"}>{slug}</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <RoleDetailTableList
            roleDetail={roleDetail}
            slug={slug}
            role={role}
            isXSmall={isXSmall}
            dataGrid={dataGrid}
            filterStatus={filterStatus}
            onValueChanged={onValueSelectChanged}
            middleware={middleware}
          />
        </div>
      </div>
    </div>
  );
}
